import {createRouter, createWebHistory} from 'vue-router';

interface RoutesType {
    path: string;
    name: string;
    component: () => {};
    meta?: {
        index?: number;
        title?: string;
        keepAlive?: boolean;
    };
    children?: RoutesType[];
}

const routes: RoutesType[] = [
    {
        path: '/',
        name: 'Home',
        component: () => import( /* webpackChunkName: "home" */ '../views/portal/Home.vue'),
        children: [{
            path: '',
            name: 'Recommend',
            component: () => import( /* webpackChunkName: "recommend" */ '../views/home/recommend/recommend.vue'),
            meta: {
                index: 1,
                keepAlive: false
            }
        },
            {
                path: 'attention/:id',
                name: 'Attention',
                component: () => import( /* webpackChunkName: "attention" */ '../views/home/attention/attention.vue'),
                meta: {
                    index: 0,
                    keepAlive: false
                }
            },
            {
                path: 'hotList',
                name: 'HotList',
                component: () => import( /* webpackChunkName: "hostList" */ '../views/home/hotList/hotList.vue'),
                meta: {
                    index: 2,
                    keepAlive: false
                }
            },
            {
                path: 'pneumonia',
                name: 'Pneumonia',
                component: () => import( /* webpackChunkName: "pneumonia" */ '../views/home/pneumonia/pneumonia.vue'),
                meta: {
                    index: 4,
                    keepAlive: false
                }
            }
        ]
    },
    {
        path: '/vip',
        name: 'Vip',
        component: () => import( /* webpackChunkName: "vip" */ '../views/vip/vip.vue'),
    },
    {
        path: '/self',
        name: 'Self',
        component: () => import( /* webpackChunkName: "self" */ '../views/self/self.vue'),
    },
    {
        path: '/notify',
        name: 'Notify',
        component: () => import( /* webpackChunkName: "notify" */ '../views/notify/notify.vue'),
    },
    {
        path: '/BFP',
        name: 'BFP',
        meta: {
            title: '三农动态',
            keepAlive: false
        },
        component: () => import('../views/public/BFP/BFP.vue'),
    },
    {
        path: '/Filing',
        name: 'Filing',
        meta: {
            title: '备案证办理',
            keepAlive: false
        },
        component: () => import('../views/public/Filing/Filing.vue'),
    },
    {
        path: '/FilingProcess',
        name: 'FilingProcess',
        meta: {
            title: '备案证办理',
            keepAlive: false
        },
        component: () => import('../views/public/Filing/FilingProcess.vue'),
    },
    {
        path: '/FilingCertificate',
        name: 'FilingCertificate',
        meta: {
            title: '备案证办理',
            keepAlive: false
        },
        component: () => import('../views/public/Filing/FilingCertificate.vue'),
    },
    {
        path: '/InformationService',
        name: 'InformationService',
        meta: {
            title: '信息服务',
            keepAlive: false
        },
        component: () => import('../views/public/InformationServices/InformationService.vue'),
    },
    {
        path: '/DemandInformationAdd',
        name: 'DemandInformationAdd',
        meta: {
            title: '需求信息发布',
            keepAlive: false
        },
        component: () => import('../views/public/InformationServices/DemandInformationAdd.vue'),
    },
    {
        path: '/ServiceInformationAdd',
        name: 'ServiceInformationAdd',
        meta: {
            title: '服务信息发布',
            keepAlive: false
        },
        component: () => import('../views/public/InformationServices/ServiceInformationAdd.vue'),
    },
    {
        path: '/EditInformation',
        name: 'EditInformation',
        meta: {
            title: '我发布的',
            keepAlive: false
        },
        component: () => import('../views/public/InformationServices/EditInformation.vue'),
    },
    {
        path: '/ArticleDetails',
        name: 'ArticleDetails',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/public/ArticleDetails.vue'),
    },
    {
        path: '/BenefitFarmersPolicy',
        name: 'BenefitFarmersPolicy',
        meta: {
            title: '政策法规',
            keepAlive: false
        },
        component: () => import('../views/public/BFP/BenefitFarmersPolicy.vue'),
    },
    {
        path: '/ProductionService',
        name: 'ProductionService',
        meta: {
            title: '技术服务',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/ProductionService.vue'),
    },
    {
        path: '/DirectoryManagement',
        name: 'DirectoryManagement',
        meta: {
            title: '名录库管理',
            keepAlive: false
        },
        component: () => import('../views/public/Directory/DirectoryManagement.vue'),
    },
    {
        path: '/DirectoryRegister',
        name: 'DirectoryRegister',
        meta: {
            title: '名录库注册',
            keepAlive: false
        },
        component: () => import('../views/public/Directory/DirectoryRegister.vue'),
    },
    {
        path: '/mobileFarmerRegister',
        name: 'mobileFarmerRegister',
        meta: {
            title: '小农户注册',
            keepAlive: false
        },
        component: () => import('../views/public/Directory/FarmerRegister.vue'),
    },
    {
        path: '/RegisterPage',
        name: 'RegisterPage',
        meta: {
            title: '用户注册',
            keepAlive: false
        },
        component: () => import('../views/public/Directory/RegisterPage.vue'),
    },
    {
        path: '/DirectoryDetails',
        name: 'DirectoryDetails',
        meta: {
            title: '名录库详情',
            keepAlive: false
        },
        component: () => import('../views/public/Directory/DirectoryDetails.vue'),
    },
    {
        path: '/NewSubjectInfo',
        name: 'NewSubjectInfo',
        meta: {
            title: '新型主体',
            keepAlive: false
        },
        component: () => import('../views/public/NewSubject/NewSubjectInfo.vue'),
    },
    {
        path: '/NewSubjectDetail',
        name: 'NewSubjectDetail',
        meta: {
            title: '新型主体',
            keepAlive: false
        },
        component: () => import('../views/public/NewSubject/NewSubjectDetail.vue'),
    },
    {
        path: '/CreditService',
        name: 'CreditService',
        meta: {
            title: '三农服务',
            keepAlive: false
        },
        component: () => import('../views/public/CreditService/CreditService.vue'),
    },
    {
        path: '/CardDetailList',
        name: 'CardDetailList',
        meta: {
            title: '更多内容',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/CardDetailList.vue'),
    },
    {
        path: '/demo',
        name: 'demo',
        meta: {
            title: '更多内容',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/InfiniteScroll.vue'),
    },
    {
        path: '/ALSDetails',
        name: 'ALSDetails',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/Details.vue'),
    },
    {
        path: '/TechnicalConsulting',
        name: 'TechnicalConsulting',
        meta: {
            title: '技术咨询',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/TechnicalConsulting.vue'),
    },
    {
        path: '/TechnicalList',
        name: 'TechnicalList',
        meta: {
            title: '技术咨询',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/TechnicalList.vue'),
    },
    {
        path: '/TechnicalDetail',
        name: 'TechnicalDetail',
        meta: {
            title: '技术咨询',
            keepAlive: false
        },
        component: () => import('../views/public/AgriculturalServices/TechnicalDetail.vue'),
    },
    {
        path: '/FinancialServices',
        name: 'FinancialServices',
        meta: {
            title: '金融服务',
            keepAlive: false
        },
        component: () => import('../views/public/PCP/FinancialServices.vue'),
    },
    {
        path: '/PCP',
        name: 'PCP',
        meta: {
            title: '产权证办理',
            keepAlive: false
        },
        component: () => import('../views/public/PCP/PCP.vue'),
    },
    {
        path: '/Mall',
        name: 'Mall',
        meta: {
            title: '数字商城',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/Mall.vue'),
    },
    {
        path: '/MallList',
        name: 'MallList',
        meta: {
            title: '商城分类',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/MallList.vue'),
    },
    {
        path: '/Mine',
        name: 'Mine',
        meta: {
            title: '我的',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/Mine.vue'),
    },
    {
        path: '/Message',
        name: 'Message',
        meta: {
            title: '消息',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/Message.vue'),
    },
    {
        path: '/MallDetails',
        name: 'MallDetails',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/MallDetails.vue'),
    },
    {
        path: '/MallLove',
        name: 'MallLove',
        meta: {
            title: '收藏',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/Love.vue'),
    },
    {
        path: '/AddressList',
        name: 'AddressList',
        meta: {
            title: '我的地址',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/AddressList.vue'),
    },
    {
        path: '/AddAddress',
        name: 'AddAddress',
        meta: {
            title: '管理地址',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/AddAddress.vue'),
    },
    {
        path: '/AddCommodity',
        name: 'AddCommodity',
        meta: {
            title: '发布商品',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/AddCommodity.vue'),
    },
    {
        path: '/CommodityEdit',
        name: 'CommodityEdit',
        meta: {
            title: '商品管理',
            keepAlive: false
        },
        component: () => import('../views/public/Mall/CommodityEdit.vue'),
    },
    {
        path: '/Feedback',
        name: 'Feedback',
        meta: {
            title: '反馈',
            keepAlive: false
        },
        component: () => import('../views/public/Feedback.vue'),
    },
    {
        path: '/subscription',
        name: 'subscription',
        meta: {
            title: '订阅管理',
            keepAlive: false
        },
        component: () => import('../views/public/Subscription.vue'),
    },
    {
        path: '/Login',
        name: 'Login',
        meta: {
            title: '登录',
            keepAlive: false
        },
        component: () => import('../views/public/Login.vue'),
    },
    {
        path: '/ResetPassword',
        name: 'ResetPassword',
        meta: {
            title: '重置密码',
            keepAlive: false
        },
        component: () => import('../views/public/ResetPassword.vue'),
    },
    {
        path: '/adminLogin',
        name: 'adminLogin',
        meta: {
            title: '登录',
            keepAlive: false
        },
        component: () => import('../views/gis/login.vue'),
    },


    {
        path: '/portal/Home',
        name: '/portal/Home',
        meta: {
            title: '首页',
            keepAlive: false
        },
        component: () => import('../views/portal/Home.vue'),
    },
    {
        path: '/portal/SanNong',
        name: '/portal/SanNong',
        meta: {
            title: '商河三农',
            keepAlive: false
        },
        component: () => import('../views/portal/SanNong.vue'),
    },
    {
        path: '/portal/Policy',
        name: '/portal/Policy',
        meta: {
            title: '本地农情',
            keepAlive: false
        },
        component: () => import('../views/portal/Policy.vue'),
    },
    {
        path: '/portal/Business',
        name: '/portal/Business',
        meta: {
            title: '业务办理',
            keepAlive: false
        },
        component: () => import('../views/portal/Business.vue'),
    },
    {
        path: '/portal/Service',
        name: '/portal/Service',
        meta: {
            title: '农服大厅',
            keepAlive: false
        },
        component: () => import('../views/portal/Service.vue'),
    },
    {
        path: '/portal/MingLu',
        name: '/portal/MingLu',
        meta: {
            title: '主体名录库',
            keepAlive: false
        },
        component: () => import('../views/portal/MingLu.vue'),
    },
    {
        path: '/portal/MingLuTable',
        name: '/portal/MingLuTable',
        meta: {
            title: '主体名录库',
            keepAlive: false
        },
        component: () => import('../views/portal/MingLuTable.vue'),
    },
    {
        path: '/portal/MingLuAdd',
        name: '/portal/MingLuAdd',
        meta: {
            title: '主体名录库',
            keepAlive: false
        },
        component: () => import('../views/portal/MingLuAdd.vue'),
    },
    {
        path: '/portal/farmerRegister',
        name: '/portal/farmerRegister',
        meta: {
            title: '小农户注册',
            keepAlive: false
        },
        component: () => import('../views/portal/farmerRegister.vue'),
    },
    {
        path: '/portal/MingLuDetails',
        name: '/portal/MingLuDetails',
        meta: {
            title: '主体名录库',
            keepAlive: false
        },
        component: () => import('../views/portal/MingLuDetails.vue'),
    },
    {
        path: '/portal/Articles',
        name: '/portal/Articles',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/portal/Articles.vue'),
    },
    {
        path: '/portal/ArticlesDetails',
        name: '/portal/ArticlesDetails',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/portal/ArticlesDetails.vue'),
    },
    {
        path: '/portal/serviceDetails',
        name: '/portal/serviceDetails',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/portal/serviceDetails.vue'),
    },
    {
        path: '/portal/Handing',
        name: '/portal/Handing',
        meta: {
            title: '详情',
            keepAlive: false
        },
        component: () => import('../views/portal/Handing.vue'),
    },
    {
        path: '/portal/ServiceInformationAdd',
        name: '/portal/ServiceInformationAdd',
        meta: {
            title: '信息发布',
            keepAlive: false
        },
        component: () => import('../views/portal/ServiceInformationAdd.vue'),
    },
    {
        path: '/portal/TGAdd',
        name: '/portal/TGAdd',
        meta: {
            title: '托管服务发布',
            keepAlive: false
        },
        component: () => import('../views/portal/TGAdd.vue'),
    },
    {
        path: '/portal/DDAdd',
        name: '/portal/DDAdd',
        meta: {
            title: '订单农业发布',
            keepAlive: false
        },
        component: () => import('../views/portal/DDAdd.vue'),
    },
    {
        path: '/portal/DemandInformationAdd',
        name: '/portal/DemandInformationAdd',
        meta: {
            title: '需求发布',
            keepAlive: false
        },
        component: () => import('../views/portal/DemandInformationAdd.vue'),
    },
    {
        path: '/portal/ListMore',
        name: '/portal/ListMore',
        meta: {
            title: '更多内容',
            keepAlive: false
        },
        component: () => import('../views/portal/ListMore.vue'),
    },
    {
        path: '/portal/CardMore',
        name: '/portal/CardMore',
        meta: {
            title: '更多内容',
            keepAlive: false
        },
        component: () => import('../views/portal/CardMore.vue'),
    },
    {
        path: '/portal/otherData',
        name: '/portal/otherData',
        meta: {
            title: '产业数据',
            keepAlive: false
        },
        component: () => import('../views/portal/otherData.vue'),
    },
    {
        path: '/portal/Insurance',
        name: '/portal/Insurance',
        meta: {
            title: '我要投保',
            keepAlive: false
        },
        component: () => import('../views/portal/Insurance.vue'),
    },
    {
        path: '/portal/Loan',
        name: '/portal/Loan',
        meta: {
            title: '我要贷款',
            keepAlive: false
        },
        component: () => import('../views/portal/Loan.vue'),
    },
    {
        path: '/LoginPage',
        name: '/LoginPage',
        meta: {
            title: '登录',
            keepAlive: false
        },
        component: () => import('../views/portal/LoginPage.vue'),
    },
    {
        path: '/Visualization',
        name: '/Visualization',
        meta: {
            title: '乡村振兴数字三农',
            keepAlive: false
        },
        component: () => import('../views/gis/Visualization.vue'),
    },
    {
        path: '/TownCenter',
        name: 'TownCenter',
        meta: {
            title: '镇街中心',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/TownCenter.vue'),
    },
    {
        path: '/TownHome',
        name: 'TownHome',
        meta: {
            title: '镇街中心',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/TownHome.vue'),
    },
    {
        path: '/toubao',
        name: 'toubao',
        meta: {
            title: '我要投保',
            keepAlive: false
        },
        component: () => import('../views/public/Insurance/toubao.vue'),
    },
    {
        path: '/daikuan',
        name: 'daikuan',
        meta: {
            title: '我要贷款',
            keepAlive: false
        },
        component: () => import('../views/public/Insurance/daikuan.vue'),
    },
    {
        path: '/butie',
        name: 'butie',
        meta: {
            title: '补贴查询',
            keepAlive: false
        },
        component: () => import('../views/public/Insurance/butie.vue'),
    },
    {
        path: '/baozai',
        name: 'baozai',
        meta: {
            title: '我要保灾',
            keepAlive: false
        },
        component: () => import('../views/public/Insurance/baozai.vue'),
    },
    {
        path: '/shouquanweituoshu',
        name: 'shouquanweituoshu',
        meta: {
            title: '授权委托书',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/forest/shouquanweituoshu.vue'),
    },
    {
        path: '/linmucaifabiao',
        name: 'linmucaifabiao',
        meta: {
            title: '林木采伐现场查验表',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/forest/linmucaifabiao.vue'),
    },
    {
        path: '/linmushenqingbiao',
        name: 'linmushenqingbiao',
        meta: {
            title: '林木采伐申请表',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/forest/linmushenqingbiao.vue'),
    },
    {
        path: '/tudijingyingquan',
        name: 'tudijingyingquan',
        meta: {
            title: '土地经营权证申请',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/land/tudijingyingquan.vue'),
    },
    {
        path: '/rentContract',
        name: 'rentContract',
        meta: {
            title: '出租合同',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/contract/rentContract.vue'),
    },
    {
        path: '/stakeContract',
        name: 'stakeContract',
        meta: {
            title: '入股合同',
            keepAlive: false
        },
        component: () => import('../views/public/TownCenter/contract/stakeContract.vue'),
    },
    // {
    //     path: '/testSign',
    //     name: 'testSign',
    //     meta: {
    //         title: 'testSign',
    //         keepAlive: false
    //     },
    //     component: () => import('../components/townCenter/testSign.vue'),
    // },
    // {
    //     path: '/testDemo',
    //     name: 'testDemo',
    //     meta: {
    //         title: 'testDemo',
    //         keepAlive: false
    //     },
    //     component: () => import('../views/public/forest/testDemo.vue'),
    // },
    // {
    //     path: '/cloudText',
    //     name: '/cloudText',
    //     meta: {
    //         title: 'cloudText',
    //         keepAlive: false
    //     },
    //     component: () => import('../components/gis/cloudText.vue'),
    // }
]
const router = createRouter({
    // createWebHistory 第一个参数为以前路由的base
    // history: createWebHashHistory(process.env.BASE_URL),
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
